import ActionLabel from '../../../../components/action-label';
import enhance from './action-label';

export default enhance(ActionLabel);
